import { Button } from "antd";
import styled from "styled-components";

export const StyledAdditionalSaleButton = styled(Button)`
    text-decoration: underline;
    text-underline-offset: 4px;
    margin-left: 10px;
`;

export const StyledMenuButton = styled(Button)`
    padding: 0;
    height: auto;

    svg {
        font-size: 20px;
    }
`;
